import { MDBAlert, MDBBtn, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { getSmartBoxSettings, updateGlobalSettings } from '../../../apiclients/streamsapi_bridge';
import SaveChanges from '../saveCancel';
import { getSbProductName } from '../../../apiclients/CommonUtils';

function SmartBoxSetting({ register, setValue, errors, watch }) {
    const sbProductName = getSbProductName();
    return (
        <>
            {/* <h3>SmartBox Settings</h3> */}

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>{sbProductName}</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.smartbox_enable")}   />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

        </>
    )
}

export default SmartBoxSetting
